import React from "react";
import "../../styles/tracker-base.css";

export default function TrackerShell({ title, left, right, children }) {
  return (
    <div className="tracker-page">
      <div className="tracker-card">
        <div className="tracker-toolbar">
          <div className="left">
            <div className="tracker-title">{title}</div>
            {left}
          </div>
          <div className="right" style={{ gridColumn: "3 / 4" }}>
            {right}
          </div>
        </div>

        <div className="tracker-viewport">{children}</div>
      </div>
    </div>
  );
}
